// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import {
  addMinutes,
  format,
  formatISO,
  getYear,
  isAfter,
  isBefore,
  isToday,
  parse,
  parseISO,
  startOfToday,
  subMinutes,
} from "date-fns";
import { ptBR } from "date-fns/locale";
import { pipe } from "ramda";

const formatDateString = (date) => format(parseISO(date), "dd/MM/yyyy");

const formatDate = (date) =>
  formatISO(parse(date, "dd/MM/yyyy", new Date()), { representation: "date" });

const formatByToken = (date, token) =>
  format(parseISO(date), token, { locale: ptBR });

const dayInPast = (date) => isBefore(parseISO(date), startOfToday());

const dateIsToday = pipe(parseISO, isToday);

const getYearFromISOString = pipe(parseISO, getYear);

const isWithinRange = (start) =>
  isAfter(new Date(), subMinutes(new Date(start), 15));

const isExpired = (expirationMinutes, date) =>
  isBefore(addMinutes(new Date(date), expirationMinutes), new Date());

export {
  dateIsToday,
  dayInPast,
  formatByToken,
  formatDate,
  formatDateString,
  getYearFromISOString,
  isExpired,
  isWithinRange,
};
